import layoutHeaderAside from '@/layout/header-aside'
const files = require.context('./', true, /\.js$/)

let componentMaps = {
  layoutHeaderAside: layoutHeaderAside,
  serviceManager: () =>
    import(
      /* webpackChunkName: "serviceManager" */ '@/pages/auth/service/index'
    ),
  userManager: () =>
    import(/* webpackChunkName: "userManager" */ '@/pages/admin/user'),
  groupManager: () =>
    import(/* webpackChunkName: "groupManager" */ '@/pages/admin/group'),
  menuManager: () =>
    import(/* webpackChunkName: "menuManager" */ '@/pages/admin/menu'),
  gateLogManager: () =>
    import(/* webpackChunkName: "gateLogManager" */ '@/pages/admin/gateLog'),
  groupTypeManager: () =>
    import(
      /* webpackChunkName: "groupTypeManager" */ '@/pages/admin/groupType'
    ),
  devFormManager: () =>
    import(/* webpackChunkName: "devFormManager" */ '@/pages/dev/build'),
  codeManager: () =>
    import(/* webpackChunkName: "codeManager" */ '@/pages/dev/code'),
  onlineManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/admin/online'),
  memberManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/user'),
  userTagManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/user/tag'),
  classificationsManager: () =>
    import(
      /* webpackChunkName: "onlineManager" */ '@/pages/demo/classification'
    ),
  commodityManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/commodity'),
  parameterManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/parameter'),
  gradeManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/grade'),
  discountManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/discount'),
  disrecordtManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/disrecord'),
  orderManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/order'),
  configurationManager: () =>
    import(
      /* webpackChunkName: "onlineManager" */ '@/pages/demo/configuration'
    ),
  ImprintManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/Imprint'),
  inspirationManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/inspiration'),
  newPeopleManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/newPeople'),
  luckDrawManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/luckDraw'),
  commandManager: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/command'),
  closeDManger: () =>
    import(/* webpackChunkName: "onlineManager" */ '@/pages/demo/close'),
  punchTheClockDManger: () => import('@/pages/demo/punchTheClock'),
  punchTheClockTpl: () => import('@/pages/demo/punchTheClockTpl'), // 任务模版管理
  taskClassificationManger: () => import('@/pages/demo/taskClassification'),
  competitionClassManger: () => import('@/pages/demo/competitionClass'),
  secondaryLabelManger: () => import('@/pages/demo/secondaryLabel'),
  recordManger: () => import('@/pages/demo/record'),
  medalManger: () => import('@/pages/demo/medal'),
  competitionDManager: () => import('@/pages/demo/competition'),
  loveDCounselor: () => import('@/pages/demo/loveCounselor'),
  loveFormReivew: () => import('@/pages/demo/loveFormReivew'),
  memberAttributes: () => import('@/pages/demo/attributes'),
  certificateListDManger: () => import('@/pages/demo/certificateList'),
  examineListDManger: () => import('@/pages/demo/examineList'),
  CommissionRelate: () => import('@/pages/demo/CommissionRelate'),
  GrowthCoin: () => import('@/pages/demo/GrowthCoin'),
  systemManger: () => import('@/pages/demo/system'),
  newsManasger: () => import('@/pages/demo/news'),
  newsListManasger: () => import('@/pages/demo/newsList'),
  sendMessageManasger: () => import('@/pages/demo/sendMessage'),
  jumpTypeManasger: () => import('@/pages/demo/jumpType'),
  growMentManger: () => import('@/pages/demo/growMent'),
  secretLanguageManger: () => import('@/pages/demo/secretLanguage'),
  keyWordManger: () => import('@/pages/demo/keyWord'),
  loveMessageRecordManager: () => import('@/pages/demo/loveMessageRecord'),
  entrustRecordManger: () => import('@/pages/demo/entrustRecord'),
  lotteryTestManger: () => import('@/pages/demo/lotteryTest'),
  mapManger: () => import('@/pages/demo/map'),
  systemTasksManger: () => import('@/pages/demo/systemTasks'),
  posterManger: () => import('@/pages/demo/poster'),
  fissionManger: () => import('@/pages/demo/fission'),
  energyManger: () => import('@/pages/demo/energy'),
  helperKeyword: () => import('@/pages/demo/helper/keyword'),
  helperContent: () => import('@/pages/demo/helper/content'),
  helperQuestionnaire: () => import('@/pages/demo/helper/questionnaire'),
  helperHuman: () => import('@/pages/demo/helper/human'),
  serviceProductCate: () => import('@/pages/merchant/service/productCate/index'),
  serviceProduct: () => import('@/pages/merchant/service/product/index'),
  promptCategory: () => import('@/pages/merchant/service/product/promptCategory'),
  promptTemplate: () => import('@/pages/merchant/service/product/promptTemplate'),
  promptChip: () => import('@/pages/merchant/service/product/promptChip'),
  serviceOrder: () => import('@/pages/merchant/service/order/index'),
  serviceProject: () => import('@/pages/merchant/service/project/index'),
  canvasLayoutTemplate: () => import('@/pages/merchant/service/project/layoutTemplate.vue'),
  fileCategory: () => import('@/pages/demo/file/category/index'),
  fileTag: () => import('@/pages/demo/file/tag/index'),
  fileResource: () => import('@/pages/demo/file/resource/index'),
  veriOrder: () => import('@/pages/demo/veriOrder/index'),
  withdrawManager: () => import('@/pages/demo/user/withdraw/index'),
  balanceOrder: () => import('@/pages/merchant/service/order/balance'),
  productSpec: () => import('@/pages/merchant/service/product/productSpec'),
  comfyuiTheme: () => import('@/pages/merchant/service/product/comfyuiTheme'),
  comfyuiPerson: () => import('@/pages/merchant/service/product/comfyuiPerson'),
  comfyuiThemeClass: () => import('@/pages/merchant/service/product/comfyuiThemeClass'),
  aigcTask: () => import('@/pages/merchant/service/project/aigcTask'),
  agentIndustry: () => import('@/pages/merchant/agent/industry/index'),
  agentBot: () => import('@/pages/merchant/agent/bot/index'),
  arGoods: () => import('@/pages/demo/arGoods/index'),
  arMsgOrder: () => import('@/pages/demo/arMsgOrder/index'),
  miniProgramQrCode: () => import('@/pages/demo/miniProgramQrCode/index.vue'),
  botAnim: () => import('@/pages/merchant/agent/bot/anim.vue'),
  botAnimFlow: () => import('@/pages/merchant/agent/bot/animFlow.vue'),
  botScene: () => import('@/pages/merchant/agent/bot/botScene.vue'),
  serviceChannelConfig: () => import('@/pages/merchant/service/channel/config.vue'),
  serviceChannelStatus: () => import('@/pages/merchant/service/channel/status.vue'),
  serviceChannelPrice: () => import('@/pages/merchant/service/channel/price.vue'),
  llmPriceManager: () => import('@/pages/merchant/service/channel/llmPrice.vue'),
  openAiProxyRequestManager: () => import('@/pages/merchant/service/channel/openAiRequests.vue'),
  channelConfigManager: () => import('@/pages/merchant/service/channel/config.vue'),
  channelStatusManager: () => import('@/pages/merchant/service/channel/status.vue'),
  channelPriceManager: () => import('@/pages/merchant/service/channel/price.vue'),
  channelLlmPriceManager: () => import('@/pages/merchant/service/channel/llmPrice.vue'),
  channelOpenAiProxyRequestManager: () => import('@/pages/merchant/service/channel/openAiRequests.vue')
}
files.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(componentMaps, files(key).default)
})
export default componentMaps
